var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attact-container"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "big-swiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "slide"
    }, [_c('img', {
      staticClass: "slide_item",
      attrs: {
        "src": item.imgUrl
      }
    })])
  }), 1), _vm._v(" "), _c('swiper', {
    ref: "swiperThumbs",
    staticClass: "small-swiper gallery-thumbs",
    attrs: {
      "options": _vm.swiperOptionThumbs
    }
  }, _vm._l((_vm.list), function(sitem, sindex) {
    return _c('swiper-slide', {
      key: 's' + sindex,
      staticClass: "slide"
    }, [_c('div', {
      staticClass: "slide_item",
      style: ({
        backgroundImage: 'url(' + sitem.imgUrl + ')'
      })
    })])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "text-wrap color-fff fs-14"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("public.name") + ":" + _vm.$t("public.exhibitionName")))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("public.venue") + ":" + _vm.$t("public.exhibitionVenue")))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("public.date") + ":" + _vm.$t("public.openDate")))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-item media_font_size_50"
  }, [_c('span', {
    staticClass: "media_font_size_30"
  }, [_vm._v(_vm._s(_vm.$t('exhibitors.invitation2025')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "media_font_size_50",
    attrs: {
      "href": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/exhibitor/2025%E5%B9%BF%E5%B7%9E%E8%BD%A6%E5%B1%95%E6%8B%9B%E5%B1%95%E5%87%BD.pdf",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('public.download')))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-download media_font_size_50"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "data-item media_font_size_50"
  }, [_c('span', {
    staticClass: "media_font_size_30"
  }, [_vm._v("2025汽车产业链及汽车文化展区招展函")]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "media_font_size_50",
    attrs: {
      "href": "https://faststatic.ccnfgame.com/cos/vrshow/autoAv/2025_lbj.pdf",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('public.download')))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-download media_font_size_50"
  })])])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91c1287c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/exhibitor/components/attact.vue
// module id = null
// module chunks = 